import { router } from '@/router'
import { api, client } from '@/api'
import { LOCAL_STORAGE_API_KEY, LOCAL_STORAGE_LOGIN_USER, LOCAL_STORAGE_CONFIG } from '../../data/localStorage'

export default {
  /**
   * ローカルストレージに認証情報があればそれを用い初期化。
   * 更にサーバー側のセッションが切れていなければ'app/initAppData'をコールしてアプリの初期化に進む。
   * @return {Boolean} アプリの初期化まで完了すればtrue, それ以外ではfalse（ルーターガードで使用）
   */
  async initAuthInfo ({ dispatch }) {
    return dispatch('setLoginInfo', {
      token: localStorage.getItem(LOCAL_STORAGE_API_KEY),
      user: JSON.parse(localStorage.getItem(LOCAL_STORAGE_LOGIN_USER)),
      config: JSON.parse(localStorage.getItem(LOCAL_STORAGE_CONFIG))
    })
  },

  /**
   * 認証情報が渡されれば、それを..
   *  1) VuexにロードしHTTPヘッダーにセットする
   *  2) アプリデータの初期化をする
   * @return {Boolean} 上記が完了すればtrue, どこかでつまづけばfalseを返す。
   */
  async setLoginInfo ({ commit, dispatch }, { token, user, config }) {
    if (token && user) {
      localStorage.setItem(LOCAL_STORAGE_API_KEY, token)
      client.authentications['tokenAuth'].apiKey = token
      commit('setToken', token)

      localStorage.setItem(LOCAL_STORAGE_LOGIN_USER, JSON.stringify(user))
      dispatch('app/setUserInfo', user, { root: true })

      localStorage.setItem(LOCAL_STORAGE_CONFIG, JSON.stringify(config))
      dispatch('app/setConfig', config, { root: true })

      await dispatch('app/initAppData', null, { root: true })
      return true
    }
    return false
  },

  // 認証情報をクリアしログイン画面に移行する。
  clearLoginInfo ({ commit }) {
    commit('setToken', '')
    localStorage.removeItem(LOCAL_STORAGE_API_KEY)
    localStorage.removeItem(LOCAL_STORAGE_LOGIN_USER)
    localStorage.removeItem(LOCAL_STORAGE_CONFIG)
    delete client.authentications['tokenAuth'].apiKey
    router.push('/login')
  },

  // ログインのリクエストを発行し、認証情報を保存する。
  async login ({ dispatch, state, commit }, request) {
    const loginInfo = await api.login(request)
    dispatch('setLoginInfo', loginInfo)

    dispatch('surveyCheck')

    return true
  },

  // ログアウトのリクエストを発行し、認証情報をクリアする。
  async logout ({ dispatch }) {
    await api.logout()
    dispatch('clearLoginInfo')
    return true
  },

  async surveyCheck ({ state, commit }) {
    const json = await fetch(process.env.SURVEY_TARGET, {
      method: 'GET',
      headers: {
        authorization: state.token
      }
    })
    const response = await json.json()
    if (response['is_survey_target']) {
      commit('app/setShowQuestionnaire', true, { root: true })
    }
  }
}
